import { createFileRoute } from "@tanstack/react-router";
import Index from "@/pages/Index";
import { publicToolHead } from "@/lib/publicToolRoutes";

const Page = () => <Index toolKey="posts" routeLang="en" />;

export const Route = createFileRoute("/en/social-posts-for-your-store")({
  head: () => publicToolHead("posts", "en"),
  component: Page,
  errorComponent: Page,
  notFoundComponent: Page,
});
